import { useQuery } from '@tanstack/react-query';
import { Button } from '@eriko/ui/src/components/ui/button';
import { Link } from 'react-router';
import { getBillingStatus } from '../api/billing';

export function TrialBanner() {
  const { data } = useQuery({
    queryKey: ['billing', 'status'],
    queryFn: getBillingStatus,
    staleTime: 60_000,
  });

  if (!data) return null;
  if (data.subscriptionStatus === 'active' || data.subscriptionStatus === 'trialing') {
    return null;
  }

  const days = data.daysLeft;
  const expired = days !== null && days <= 0;
  const message = expired
    ? "Your free trial has ended. Subscribe to keep using Eriko."
    : `${days} day${days === 1 ? '' : 's'} left in your free trial.`;

  return (
    <div
      className={`flex items-center justify-between gap-3 px-4 py-2 text-xs ${
        expired
          ? 'bg-red-50 text-red-800 border-b border-red-200'
          : 'bg-amber-50 text-amber-800 border-b border-amber-200'
      }`}
    >
      <span>{message}</span>
      <Link to="/billing">
        <Button size="sm" variant={expired ? 'default' : 'outline'}>
          {expired ? 'Subscribe — $99/mo' : 'Subscribe'}
        </Button>
      </Link>
    </div>
  );
}
